export default __webpack_public_path__ + "maps-examples-animate-image-layer-1200-f369c74784f3f1170758288edccbd6d0.png";